import { render } from "./Post.vue?vue&type=template&id=6ac9c062"
import script from "./Post.vue?vue&type=script&lang=ts"
export * from "./Post.vue?vue&type=script&lang=ts"

import "./Post.vue?vue&type=style&index=0&id=6ac9c062&lang=scss"
script.render = render

export default script